import React, { useState, useEffect, useMemo } from 'react'
import Controllers from '../../Api/Controllers';
import ForoForm from './ForoForm'
import { toast } from 'react-toastify';
import Helpers from '../../Components/Helpers/Helpers';
import SweetAlert from '../../Components/SweetAlert/SweetAlert'
import { ListPageShell, SideDrawer, EmptyState } from '../../Components/Ui'
import { Link } from 'react-router-dom';
import ReactPlaceholder from 'react-placeholder/lib';

const avatarFallback = (e) => {
    e.currentTarget.style.display = 'none'
    if (e.currentTarget.nextSibling) e.currentTarget.nextSibling.style.display = 'inline-flex'
}

const Foro = ({ nameSingle, namePlural, separator }) => {
    const [modalShow, setModalShow] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [reload, setReload] = useState(true);
    const [rows, setRows] = useState([])
    const [loadSubmit, setLoadSubmit] = useState(false)
    const [dataUpdated, setDataUpdated] = useState({})
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const [loadSubmitDelete, setLoadSubmitDelete] = useState(false)
    const [dataDeleted, setDataDeleted] = useState({})
    const [ready, setReady] = useState(false)
    const [categories, setCategories] = useState([])
    const [formFilter, setFormFilter] = useState({
        p_id_category: '',
        p_text_filter: ''
    })
    const [readyCategory, setReadyCategory] = useState(false)
    const [localSearch, setLocalSearch] = useState('')

    useEffect(() => {
        Controllers.category.get_category().then(res => {
            setCategories([
                { id_category: '', name_category: 'Todas' },
                ...res.data,
            ])
            setReadyCategory(true)
        })
    }, [])

    useEffect(() => {
        if (reload) {
            setReady(false)
            Controllers.foro.get_foro(formFilter).then(res => {
                setRows(res.data)
                setReady(true)
            }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setReload(false)
            })
        }
    }, [reload, formFilter])

    const handleInsertUpdate = ({ data }) => {
        setLoadSubmit(true)
        Controllers.foro.foro_insert_update(data).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setModalShow(false)
                setDataUpdated({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => {
            setLoadSubmit(false)
            setReload(true)
        })
    }

    const handleGet = e => {
        let $this = e.currentTarget

        if (!$this.dataset?.idForo) {
            setModalTitle(`Registrar ${nameSingle}`)
            setDataUpdated({})
            setModalShow(true);
            return
        }

        let buttonHTML = $this.innerHTML;
        $this.innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>'
        let { idForo } = $this.dataset

        Controllers.foro.get_foro_id({ p_id_foro: idForo }).then(res => {
            setModalTitle(`Modificar ${nameSingle} #${idForo}`)
            setDataUpdated({ data: res.data })
            setModalShow(true);
        }).catch(req => {
            Helpers.promise.catch({ req, toast })
            setReload(true)
        })
        .finally(() => $this.innerHTML = buttonHTML)
    }

    const handleOpenCreate = () => {
        setModalTitle(`Registrar ${nameSingle}`)
        setDataUpdated({})
        setModalShow(true)
    }

    const handleDelete = () => {
        setLoadSubmitDelete(true)

        Controllers.foro.foro_delete(dataDeleted).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setShowConfirmDelete(false)
                setDataDeleted({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => {
            setReload(true)
            setLoadSubmitDelete(false)
        })
    }

    const handleHideModalForm = () => {
        setModalShow(false)
        setLoadSubmit(false)
    }

    const handleHideModalDelete = () => setShowConfirmDelete(false)

    const applySearch = () => {
        setFormFilter({ ...formFilter, p_text_filter: localSearch })
        setReload(true)
    }

    return <>
        <ListPageShell
            eyebrow="Super Papelera — Espacio de trabajo"
            title="Histórico del Foro"
            subtitle="Explora temas, filtra por departamento y crea nuevas conversaciones."
            badge="Actividad actualizada"
            primaryAction={
                <ListPageShell.PrimaryButton onClick={handleOpenCreate} icon="fa fa-plus">
                    Crear {nameSingle}
                </ListPageShell.PrimaryButton>
            }
            onSearch={applySearch}
            filters={[
                {
                    label: 'Departamento',
                    control: (
                        <select
                            value={formFilter.p_id_category}
                            disabled={!readyCategory}
                            onChange={e => {
                                setFormFilter({ ...formFilter, p_id_category: e.target.value })
                                setReload(true)
                            }}
                        >
                            {categories.map(j => (
                                <option key={String(j.id_category)} value={j.id_category}>{j.name_category}</option>
                            ))}
                        </select>
                    )
                },
                {
                    label: 'Buscar',
                    control: (
                        <input
                            type="search"
                            placeholder="Buscar tema…"
                            value={localSearch}
                            onChange={e => setLocalSearch(e.target.value)}
                            onKeyDown={e => { if (e.key === 'Enter') applySearch() }}
                        />
                    )
                }
            ]}
        >
            <ReactPlaceholder ready={ready} showLoadingAnimation rows={12}>
                {rows.length === 0 ? (
                    <EmptyState
                        icon="fa fa-comments"
                        title="No hay temas en el foro"
                        text="Crea el primero para iniciar la conversación."
                        action={
                            <ListPageShell.PrimaryButton onClick={handleOpenCreate}>
                                Crear {nameSingle}
                            </ListPageShell.PrimaryButton>
                        }
                    />
                ) : (
                    <div style={{ padding: '8px 4px 12px' }}>
                        {React.Children.toArray(rows.map(r => (
                            <Link className="sp-feed-card" to={Helpers.config.convertUrl({ url: '/foro/' + r.token_foro })}>
                                <div style={{ position: 'relative' }}>
                                    <img
                                        src={Helpers.config.resourcesUrl({ url: r.file_photo_foro })}
                                        width="48"
                                        height="48"
                                        alt=""
                                        style={{ borderRadius: 999, objectFit: 'cover' }}
                                        onError={avatarFallback}
                                    />
                                    <span className="sp-avatar-fallback" style={{ display: 'none', width: 48, height: 48 }}>
                                        <i className="fa fa-user" />
                                    </span>
                                </div>
                                <div style={{ minWidth: 0, flex: 1 }}>
                                    <h6>{r.name_foro}</h6>
                                    <p>{r.observation_foro}</p>
                                    <small className="sp-comment-meta">{r.date_created}</small>
                                </div>
                                <i className="fa fa-chevron-right align-self-center" style={{ color: '#9CA3AF' }} />
                            </Link>
                        )))}
                    </div>
                )}
            </ReactPlaceholder>
        </ListPageShell>

        <SideDrawer
            open={modalShow}
            onClose={handleHideModalForm}
            title={modalTitle}
            subtitle="Completa la información del tema del foro."
        >
            <ForoForm onSubmit={handleInsertUpdate} loadSubmit={loadSubmit} {...dataUpdated} />
        </SideDrawer>

        <SweetAlert
            icon="delete"
            show={showConfirmDelete}
            showCancelButton
            title={<>¿Desea eliminar {separator} {nameSingle}?</>}
            subtitle={<>#{dataDeleted.p_id_foro} - {dataDeleted.p_name_foro}</>}
            confirmButtonText="¡Sí, eliminar!"
            cancelButtonText="¡No!"
            loadSubmit={loadSubmitDelete}
            onCancel={handleHideModalDelete}
            onConfirm={handleDelete}
        />
    </>
}

export default Foro
